export const italicFont = () => ({
  fontStyle: "italic",
});

export const fontSize = {
  10: "0.625rem",
  11: "0.6875rem",
  12: "0.75rem",
  13: "0.81rem",
  14: "0.87rem",
  15: "1.06rem",
  16: "1.125rem",
  17: "1.18rem",
  18: "1.25rem",
  19: "1.31rem",
  20: "1.37rem",
  21: "1.43rem",
  22: "1.5rem",
  23: "1.56rem",
  24: "1.62rem",
  25: "1.687rem",
  26: "1.75rem",
  27: "1.81rem",
  28: "1.87rem",
  29: "1.93rem",
  30: "2rem"
};